import { useIsFetching } from "@tanstack/react-query";
import { getQueryKey } from "@trpc/react-query";
import { trpc } from "../modules/main/components/trpc.ts";
import styles from "./RdvsLoading.module.css";
import Loader from "../modules/agenda/components/Loader";

const RdvsLoading = () => {
  const rdvFetchKeys = getQueryKey(trpc.rdv);
  const isFetching = useIsFetching({ queryKey: rdvFetchKeys });
  return (
    <>
      {isFetching ? (
        <div className={styles.loadingStyle} id="redloading">
          <Loader />
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default RdvsLoading;
